namespace TabAurous.ECommerce {
    export namespace FootfallAndSalesService {
        export const baseUrl = 'ECommSales/FootfallAndSales';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ECommSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ECommSales/FootfallAndSales/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>FootfallAndSalesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
